export enum APPLICATION_EVENT {
    LOCATION_CHANGE = 'LOCATION_CHANGE',
    BUTTON_CLICK = 'BUTTON_CLICK',
}
